(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ctms"] = factory();
	else
		root["lib"] = root["lib"] || {}, root["lib"]["ctms"] = factory();
})(window, function() {
return 